/* ML site fixes (Optimization preview)
   1) Locale-safe links: on market subfolders (e.g. /en-us) root-relative links such as /pages/x drop the
      visitor back to the primary market (CAD). Prefix them with Shopify.routes.root.
   2) Live header cart count: Upcart and the theme's own AJAX add-to-cart don't update the header
      count, so refresh it from cart.js whenever a cart request finishes. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* ---------- 1) locale-safe links ---------- */
  if (root !== '/') {
    var pre = root.replace(/\/$/, ''); /* e.g. "/en-us" */
    var ok = /^\/(collections|products|pages|blogs|search|cart|account)(\/|\?|#|$)|^\/(\?|#|$)/;
    var fix = function (a) {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return;
      if (h === pre || h.indexOf(pre + '/') === 0 || h.indexOf(pre + '?') === 0) return;
      if (!ok.test(h)) return;
      a.setAttribute('href', pre + (h === '/' ? '' : h));
    };
    var fixAll = function (scope) { (scope || document).querySelectorAll('a[href^="/"]').forEach(fix); };
    var fixForm = function (f) {
      var ac = f.getAttribute('action');
      if (ac && ac.charAt(0) === '/' && ac.charAt(1) !== '/' && ac.indexOf(pre + '/') !== 0 && /^\/(search|cart|localization)?(\/|\?|$)/.test(ac) && !/^\/localization/.test(ac)) f.setAttribute('action', pre + ac);
    };
    var run = function () { fixAll(); document.querySelectorAll('form[action^="/"]').forEach(fixForm); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href^="/"]'); if (a) fix(a); }, true);
    document.addEventListener('submit', function (e) { if (e.target && e.target.tagName === 'FORM') fixForm(e.target); }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (n.matches && n.matches('a[href^="/"]')) fix(n); if (n.querySelectorAll) fixAll(n); }); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  /* ---------- 2) live header cart count ---------- */
  var busy = false, again = false;
  function refreshCount() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-number,[data-cart-count-number]').forEach(function (n) {
          if (String(n.textContent).trim() !== String(c.item_count)) n.textContent = c.item_count;
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refreshCount(); } });
  }
  var CART_RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (CART_RX.test(e.name)) refreshCount(); });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }
  ['cart:updated', 'cart:refresh', 'upcart:cart:updated', 'cart-drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (!(e.detail && e.detail.cart)) refreshCount(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
